import { FC } from 'react';

import { TournamentCardPlayerHolder } from '../TournamentCardPlayerHolder';

import './TournamentCardTeamSection.scss';

interface TournamentCardTeamSectionProps {
    team: number;
    player1?: string;
    player2?: string;
}

export const TournamentCardTeamSection: FC<TournamentCardTeamSectionProps> = ({ team, player1 = '', player2 = '' }) => {

    return (<div className="tournament-card-team-section">
        <div className="tournament-card-team-section__side tournament-card-team-section__side_left">
            <TournamentCardPlayerHolder team={team} player="1" teamPlayer={player1} />
        </div>
        <div className="tournament-card-team-section__side tournament-card-team-section__side_right">
            <TournamentCardPlayerHolder team={team} player="2" teamPlayer={player2} />
        </div>
    </div>);
};